<template>
  <v-expansion-panel @mouseover.native="hover=true" @mouseleave.native="hover=false">
    <v-expansion-panel-header hide-actions>
      {{ cassetteTitle }}
      <div class="cassette-header-buttons-container" :class="{ hover: hover }">
        <v-btn icon :height="'24px'" :width="'24px'" class="cassette-button" @click.stop="$emit('open-cassette-form', cassette)">
          <v-icon size="20" color="accent">edit</v-icon>
        </v-btn>
        <v-btn icon :height="'24px'" :width="'24px'" class="cassette-button" @click.stop="$emit('open-delete-cassette-dialog', { uuid: cassette.ct_uuid, label: cassette.ct_label ? cassette.ct_label : ''+cassette.ct_id })">
          <v-icon size="20" color="accent">delete</v-icon>
        </v-btn>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <connection
        v-for="(connection, positionInCassette) of connections"
        class="connection"
        :key="positionInCassette"
        :connection="cassetteIsVirtualCassette ? connection : getConnectionByIndex(positionInCassette+1)"
        @open-menu="openMenu"
        @open-tube-form="openTubeForm($event, positionInCassette+1)"
      >
      </connection>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Connection from "./Connection"
export default {
  name: "Cassette",

  components: {
    Connection,
  },

  props: {
    cassette: {
      type: Object,
      required: true,
    },

    connections: {
      type: Array,
    },
  },

  data() {
    return {
      hover: false,
    }
  },

  computed: {
    /**
     * Indicates if the cassette has any leftover capcaity
     *
     * @return {Boolean}
     */
    cassetteHasLeftoverCapacity() {
      return this.cassette.ct_capacity > this.connections.length
    },

    cassetteIsVirtualCassette() {
      return this.cassette.ct_capacity === 9999999;
    },

    cassetteTitle() {
      let identifier = this.cassette.ct_label ? this.cassette.ct_label : this.cassette.ct_id;
      return this.cassetteIsVirtualCassette ? identifier + " (" + this.$i18n.tc("Virtual", 1) + ")" : identifier;
    }
  },

  methods: {
    /**
     * Emits an event to open the fiber menu
     *
     * @param {Event} e the click event
     * @param {String} fiberId the clicked fiber id
     * @param {String} side the connection side of the clicked fiber
     */
    openMenu(data) {
      this.$emit('open-cassette-connection-menu', {
        e: data.e,
        fiberId: data.fiberId,
        side: data.side
      });
    },

    /**
     * Emits an event to open the tube form
     *
     * @param {String} data the data of the selected connection
     * @param {String} positionInCassette the position of the connection in the cassette
     */
    openTubeForm(data, positionInCassette) {
      this.$emit('open-tube-form',
        data.connectionSide,
        {
          trayMaterial: this.cassette.ct_material_id,
          trayLabel: this.cassette.ct_label,
          trayFace: this.cassette.ct_face,
          trayNumber: this.cassette.ct_id,
          trayParentDrawerId: this.cassette.ct_drawer_id,
        },
        this.cassette.ct_capacity - this.connections.length,
        this.cassette.ct_capacity,
        positionInCassette,
        data.connectionId
      );
    },

    getConnectionByIndex(positionInCassette) {
      let connection = this.connections.filter(connection => connection.positionInCassette === positionInCassette);
      return connection.length > 0 ? connection[0] : {};
    }
  },
}
</script>

<style scoped>
.v-expansion-panel {
  background-color: #cedce0 !important;
  margin-top: 10px;
  border-radius: 8px;
  cursor: inherit;
}

.v-expansion-panel-header {
  justify-content: center;
}
.connection {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.cassette-button {
  max-width: 24px;
}

.cassette-header-buttons-container {
  position: absolute;
  right: 24px;
  opacity : 0;
  transition:opacity .3s;
}

.cassette-header-buttons-container.hover {
  opacity : 1;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/InsidePlan/Cassette.vue